module.exports = "/_next/static/images/main-visual-home@2x-a90fe94ce1d4748ef86189ee7fd77af6.jpg";